import { LANGS, useI18n, useT } from "./i18n";

/**
 * The language selector.
 *
 * It writes to localStorage, so the choice is per-device rather than per
 * account: the same person reasonably wants English on a work laptop and
 * Spanish on their phone, and storing it server-side would force one on both.
 */
export default function LanguagePicker() {
  const { lang, setLang } = useI18n();
  const t = useT();

  return (
    <section className="rounded border border-current/20 p-5">
      <h2 className="text-xs font-semibold uppercase tracking-widest opacity-60">
        {t("settings.language")}
      </h2>
      <div className="mt-4 flex gap-2" role="group" aria-label={t("settings.language")}>
        {LANGS.map(({ code, label }) => (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            aria-pressed={lang === code}
            className={
              "rounded border px-4 py-2 text-sm font-semibold " +
              (lang === code
                ? "border-current bg-current/10"
                : "border-current/25 opacity-70 hover:opacity-100")
            }
          >
            {label}
          </button>
        ))}
      </div>
      <p className="mt-3 text-sm opacity-60">{t("settings.language.hint")}</p>
    </section>
  );
}
